import { render, staticRenderFns } from "./people-screen.vue?vue&type=template&id=34c1f840&"
import script from "./people-screen.vue?vue&type=script&lang=js&"
export * from "./people-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c1f840')) {
      api.createRecord('34c1f840', component.options)
    } else {
      api.reload('34c1f840', component.options)
    }
    module.hot.accept("./people-screen.vue?vue&type=template&id=34c1f840&", function () {
      api.rerender('34c1f840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/people-screen.vue"
export default component.exports